import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";

export const RegularizationsTab = () => {
  const [regs, setRegs] = useState([]);

  const load = () => api.get("/regularizations").then((r) => setRegs(r.data));
  useEffect(() => { load(); }, []);

  const review = async (id, status) => {
    try {
      await api.put(`/regularizations/${id}`, { status });
      toast.success(`Regularization ${status}`);
      load();
    } catch (e) { toast.error(errText(e)); }
  };

  return (
    <div className="bg-white border border-stone-200 rounded-lg divide-y divide-stone-100">
      {regs.length === 0 && <p className="p-8 text-center text-stone-400">No regularization requests.</p>}
      {regs.map((r) => (
        <div key={r.id} className="p-5 flex flex-wrap items-center justify-between gap-3">
          <div>
            <div className="font-semibold text-sm">{r.employee_name} · {r.date}</div>
            <div className="text-xs text-stone-500">Requested {r.requested_in} → {r.requested_out} · {r.reason}</div>
          </div>
          {r.status === "pending" ? (
            <div className="flex gap-2">
              <button onClick={() => review(r.id, "approved")} data-testid={`approve-reg-${r.id}`} className="tap-scale px-5 py-2.5 rounded-full bg-green-700 text-white text-sm font-bold hover:bg-green-800 transition-colors duration-200">Approve</button>
              <button onClick={() => review(r.id, "rejected")} data-testid={`reject-reg-${r.id}`} className="tap-scale px-5 py-2.5 rounded-full bg-white border border-stone-300 text-sm font-bold text-stone-700 hover:bg-stone-50 transition-colors duration-200">Reject</button>
            </div>
          ) : <span className={`text-xs font-bold px-3 py-1.5 rounded-full ${r.status === "approved" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"}`}>{r.status}</span>}
        </div>
      ))}
    </div>
  );
};
